import type { StandardizedApiError } from '@/services/client/types';

import { logger } from '@/instrumentation/logger';
import { isClientError, isServerError } from '../utills';

export const useHandleQueryErrors = () => {
  const handleErrors = (error: StandardizedApiError) => {
    if (isServerError(error.statusCode)) {
      // show translated error message in toast/snackbar
      logger.error(error.originalError.message);
    }

    if (isClientError(error.statusCode)) {
      // show translated error message in toast/snackbar
      logger.error(error.originalError.message);
    }
  };

  return { handleErrors };
};
